import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'

type Props = {}

const ManageVideos: React.FC<Props> = ({ }: Props) => {
    return (
        <ManageBooks
            button_add_name='เพิ่มวีดีโอ'
            category={ELibraryCategory.VIDEO}
            menu_name={'จัดการวีดีโอ'}
            path_create={routeName.e_library.manage_videos_create}
        />
    )
}

export default ManageVideos